import { Box, FormControlLabel, Grid, Switch, Typography } from "@mui/material"
import { HeaderFiltro } from "../header-filtro"
import { SexoKeys } from "../../../../../../../application/models"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useProjetosService } from "../../../../../../../use-cases/geo-veles"
import React from "react"

export const sexoKeyToLabel = (sexoKey: string) => {
    switch (sexoKey) {
        case 'MASCULINO':
            return 'Masculino'
        case 'FEMININO':
            return 'Feminino'
        default:
            return 'Não definido'
    }
}

export const FiltroSexo = () => {
    // State
    const { filtrosSelecionados } = useAppSelector((state) => state.projetos)
    // Hook
    const { addSexoFilter, removeSexoFilter } = useProjetosService()

    return (
        <>
            <HeaderFiltro 
                titulo="Sexo"
                descricao={
                    <>
                        <Typography style={{ marginBottom: '10px' }}>
                            Esta opção permite buscar pessoas pelo sexo, sendo masculino ou feminino.
                        </Typography>
                        <Typography>
                            Caso nenhuma opção seja selecionada, consideraremos todas as opções.
                        </Typography>
                    </>
                }
            />

            <Box p={3}>
                <Grid container spacing={3}>
                    {SexoKeys.map((sexo) => (
                        <Grid item xs={12} key={sexo}>
                            <FormControlLabel
                                label={sexoKeyToLabel(sexo).toUpperCase()}
                                control={
                                    <Switch
                                        checked={filtrosSelecionados?.sexo?.includes(sexo) ?? false}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                addSexoFilter(sexo)
                                            } else {
                                                removeSexoFilter(sexo)
                                            }
                                        }}
                                    />
                                }
                            />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </>
    )
}
